<!-- 人工服务 ArtificialServices-->
<template>
  <div class="ArtificialServices">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="100px">
        <div class="form_list">
          <el-form-item label="用户名称：">
            <el-input v-model="userform.name"></el-input>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="userform.status" placeholder="请选择状态">
              <el-option label="已回复" value="1"></el-option>
              <el-option label="未回复" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div style="margin-left:20px">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="cancel">取消</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="username" label="用户名称" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.user.username}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.user.email}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="反馈内容"></el-table-column>
        <el-table-column prop="created_at" label="反馈时间">
          <template slot-scope="scope">
            <span>{{filterTime(scope.row.created_at)}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
            <el-button v-if="scope.row.status==0" type="text" size="small" @click="reply(scope.row)">回复</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 回复--弹窗 -->
    <el-dialog :title="titName" :visible.sync="pop_up">
      <el-form :model="Edform" label-width="100px">
        <el-form-item label="回复内容：">
          <el-input v-model="Edform.news" type="textarea" :rows="2"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pop_up = false">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 消息详情 ----弹窗 delitpop -->
    <el-dialog title="详情" :visible.sync="pop_two">
      <el-form :model="delitpop" label-width="100px">
        <el-form-item label="反馈内容：">
          <div>{{delitpop.content}}</div>
        </el-form-item>

        <el-form-item label="反馈图片：" v-if="delitpop.imgs.length>0">
          <div class="log_img" v-for="(item,i) in delitpop.imgs" :key="i">
            <img :src="item" alt />
          </div>
        </el-form-item>
        <el-form-item label="反馈时间：">
          <div>{{ filterTime(delitpop.created_at)}}</div>
        </el-form-item>
        <el-form-item label="已回复：" v-if="delitpop.reply">
          <div>{{ delitpop.reply}}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { msglists, msgreply, msgdetail } from "../api/comm.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        status: "",
        name: ""
      },
      Edform: {
        news: ""
      },
      userList: [
        {
          user: {
            username: "",
            email: ""
          },
          province: "积分够为什么领取失败"
        }
      ],
      titName: "回复",
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      pop_up: false,
      replyId: "",
      pop_two: false,
      delitpop: {
        imgs: []
      }
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //  时间换算
    filterTime(time) {
      var date = new Date(Number(time + "000"));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d;
    },
    //反馈消息列表
    msgdata() {
      // console.log(this.userform);
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        status: this.userform.status,
        username: this.userform.name
      };
      msglists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.userList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.msgdata();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.msgdata();
    },
    cancel() {
      this.currentindex = 1;
      this.userform.name = "";
      this.userform.status = "";
      this.msgdata();
    },
    //查看详情
    handleClick(e) {
      // console.log(e);
      let data = {
        id: e.id
      };
      msgdetail(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          if (res.data.imgs) {
            res.data.imgs = res.data.imgs.split(",", "");
          } else {
            res.data.imgs = [];
          }
          this.delitpop = res.data;
          this.pop_two = true;
        }
      });
    },
    //回复弹窗
    reply(e) {
      // console.log(e);
      this.titName = "回复" + e.user.username;
      this.replyId = e.id;
      this.pop_up = true;
    },
    //确定回复
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.Edform.news !== "") {
        let data = {
          id: this.replyId,
          reply: this.Edform.news
        };
        msgreply(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.pop_up = false;
            this.currentindex = 1;
            this.userform.name = "";
            this.userform.status = "";
            this.msgdata();
            this.$message({
              message: "回复成功",
              type: "success"
            });
          }
        });
      } else {
        this.$message({
          message: "请将回复内容填写完整",
          type: "warning"
        });
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.msgdata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.ArtificialServices {
  padding: 20px 30px 0;
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
  .log_img {
    img {
      width: calc(100% / 5);
    }
  }
}
</style>
<style lang='scss'>
.ArtificialServices {
  .el-form-item {
    margin-bottom: 0;
  }
  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>